// extracted by mini-css-extract-plugin
export default {"Switch":"S5vHKDr6A33fCiQTv5J6","Input":"u_cMnav0mw80ZPi6QdbN","Slider":"zfp4j7J0wkcIB5eH0yoe"};